<div
  class="card"
  [class.modal]="modal()"
  [class.status-ok]="normalizedStatus() === 'ok'"
  [class.status-warning]="normalizedStatus() === 'warning'"
  [class.status-alert]="normalizedStatus() === 'alert'"
  [class.mobile]="isMobile()"
>
  <div class="disabled-blocker"></div>

  <!-- Header template injected into nz-card when status is NOT 'none' -->
  <ng-template #statusheader>
    <div class="status_message_wrapper">
      <i nz-icon nzType="icons:info" class="status-icon svg-icon"></i>
      <span class="status_message">{{
        message() ?? i18n.langString("status")
      }}</span>
    </div>
  </ng-template>

  <nz-card
    [nzTitle]="normalizedStatus() !== 'none' ? statusheader : ''"
    [nzBodyStyle]="applyBodyStyle()"
  >
    @if (!fine() || detail()) {
      <ng-content></ng-content>
    }
  </nz-card>
</div>
